export const PROCESSING_METHOD = {
  EASYTIP_LOCAL_GATEWAY: 'EASYTIP_LOCAL_GATEWAY',
  CLIENT_GATEWAY: 'CLIENT_GATEWAY',
  NO_PAYMENT_GATEWAY: 'NO_PAYMENT_GATEWAY',
};
